// extracted by mini-css-extract-plugin
module.exports = {"productImage":"_1KgXwA","placement":"_3DPDTJ"};